module.exports = __webpack_public_path__ + "static/media/right_arrow.fc43ee21.svg";